export default __webpack_public_path__ + "static/media/42k.53cdac46.yaml";